import BoxForm from './BoxForm';
export default BoxForm;


// WEBPACK FOOTER //
// ./src/components/BoxForm/index.js